import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-29ac2e5f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "audiosContainer"
};
const _hoisted_2 = {
  class: "topcontainer"
};
const _hoisted_3 = {
  class: "exhibition-img"
};
const _hoisted_4 = {
  class: "swiper swiper-container",
  ref: "swiperNav"
};
const _hoisted_5 = {
  class: "swiper-wrapper"
};
const _hoisted_6 = {
  class: "swiper-image swiper-slide"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  class: "viewNum type"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-view"
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-like"
}, null, -1));
const _hoisted_11 = {
  class: "audio"
};
const _hoisted_12 = {
  class: "slider"
};
const _hoisted_13 = {
  class: "nowTime"
};
const _hoisted_14 = {
  class: "bottomContainer"
};
const _hoisted_15 = {
  class: "exhibition-container"
};
const _hoisted_16 = {
  key: 0,
  class: "changeLanguage"
};
const _hoisted_17 = {
  class: "exhibition-box"
};
const _hoisted_18 = {
  class: "title"
};
const _hoisted_19 = {
  key: 0,
  class: "type"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-address"
}, null, -1));
const _hoisted_21 = {
  class: "number"
};
const _hoisted_22 = {
  class: "exhibiton-content"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "richtext",
  id: "editor1"
}, null, -1));
const _hoisted_24 = [_hoisted_23];
const _hoisted_25 = ["src"];
const _hoisted_26 = {
  key: 2,
  ref: "listaudioItem",
  id: "listaudio",
  preload: "auto"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "recommend"
};
const _hoisted_29 = {
  class: "recommend-title"
};
const _hoisted_30 = {
  class: "titleWarp"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1));
const _hoisted_32 = {
  class: "recom-title"
};
const _hoisted_33 = {
  class: "recommendList"
};
const _hoisted_34 = {
  class: "swiper swiper-container",
  ref: "recommonedSwiper"
};
const _hoisted_35 = {
  class: "swiper-wrapper"
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  class: "imgbox"
};
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  class: "name"
};
const _hoisted_40 = {
  class: "txtbox"
};
const _hoisted_41 = {
  class: "audio-menuv2"
};
const _hoisted_42 = ["innerHTML"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
  key: 0,
  class: "exhibition-address"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-address"
}, null, -1));
const _hoisted_46 = {
  class: "number"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_guideTheme = _resolveComponent("guideTheme");
  const _component_van_slider = _resolveComponent("van-slider");
  const _component_guideBottom = _resolveComponent("guideBottom");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audioDetail ${_ctx.$route.query.fid == 152288 ? 'nxbwgAudio' : ''}`),
    onTouchstart: _cache[12] || (_cache[12] = (...args) => $options.touchstart && $options.touchstart(...args))
  }, [_createVNode(_component_guideTheme), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imgList, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_7)]);
  }), 256))])], 512)]), $data.antiqueDetail.viewNum ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", null, _toDisplayString($data.antiqueDetail.viewNum), 1)])) : _createCommentVNode("", true), $data.antiqueDetail.likeNum || $data.antiqueDetail.likeNum === '0' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["likebtn type", {
      'on': $data.isLiked
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $options.editFormData(2))
  }, [_hoisted_10, _createElementVNode("span", null, _toDisplayString($data.antiqueDetail.likeNum), 1)], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.clickPlay && $options.clickPlay(...args)),
    class: "play"
  }, [_createElementVNode("i", {
    class: _normalizeClass($data.isPlaying ? 'icon-pause' : 'icon-video1')
  }, null, 2)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString($data.nowTime), 1), _createVNode(_component_van_slider, {
    "active-color": _ctx.$route.query.fid == 152288 ? '#fff' : '#bca265',
    "inactive-color": _ctx.$route.query.fid == 152288 ? '#fff' : '#bca265',
    modelValue: $data.ctTime,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.ctTime = $event),
    "button-size": "10px",
    max: $data.maxValue,
    style: {
      "margin": "0 0.3rem"
    },
    disabled: !$data.hasPalyed,
    onDragStart: $options.startMove,
    onChange: $options.changeTime
  }, null, 8, ["active-color", "inactive-color", "modelValue", "max", "disabled", "onDragStart", "onChange"]), _createElementVNode("span", {
    class: _normalizeClass(`totalTime ${!$data.totalTime ? 'timaLoading' : ''}`)
  }, _toDisplayString($data.totalTime), 3)])], 512), [[_vShow, $data.audioPath]])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [$data.antiqueDetail.en_explainObj || $data.antiqueDetail.fangyanleixing ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", {
    class: _normalizeClass(!_ctx.language && !$data.languageType || $data.languageType == 1 ? 'active' : ''),
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => $options.changeLanguage(1), ["self"]))
  }, "普通话", 2), $data.antiqueDetail.fangyanleixing ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass($data.languageType == 2 ? 'active' : ''),
    onClick: _cache[4] || (_cache[4] = _withModifiers($event => $options.changeLanguage(2), ["self"]))
  }, _toDisplayString($data.antiqueDetail.fangyanleixing), 3)) : _createCommentVNode("", true), $data.antiqueDetail.en_explainObj ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(_ctx.language && !$data.languageType || $data.languageType == 3 ? 'active' : ''),
    onClick: _cache[5] || (_cache[5] = _withModifiers($event => $options.changeLanguage(3), ["self"]))
  }, "English", 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("div", {
    class: "linkUrl type",
    onClick: _cache[6] || (_cache[6] = _withModifiers($event => $options.openUrl($data.antiqueDetail.zhishituozhan), ["stop"]))
  }, "知识拓展", 512), [[_vShow, $data.antiqueDetail.zhishituozhan && !_ctx.language]]), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.language ? $data.antiqueDetail.en_explainObj : $data.antiqueDetail.explainObj), 1), !$data.hasChangeLanguage ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(!$data.hasChangeLanguage ? $data.location : ''), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
    id: "desc",
    class: _normalizeClass(`txtcon ${$data.isFolded && $data.descflag ? 'hide' : ''}`)
  }, _hoisted_24, 2), _withDirectives(_createElementVNode("div", {
    onClick: _cache[7] || (_cache[7] = (...args) => $options.toggleFold && $options.toggleFold(...args)),
    class: _normalizeClass(`state ${$data.isFolded ? 'nofold' : 'fold'}`)
  }, [_createElementVNode("span", null, _toDisplayString($data.isFolded ? `${this.language ? 'all' : '展开全部'}` : `${this.language ? 'up' : '收起'}`), 1), _createElementVNode("i", {
    class: _normalizeClass(["icon-arrow-bottom1", {
      'up': !$data.isFolded
    }])
  }, null, 2)], 2), [[_vShow, $data.descflag]])])]), $data.audioPath ? (_openBlock(), _createElementBlock("audio", {
    key: 1,
    ref: "audioItem",
    id: "audio",
    preload: "auto",
    onCanplay: _cache[8] || (_cache[8] = $event => $options.getDuration('audioItem')),
    onTimeupdate: _cache[9] || (_cache[9] = (...args) => $options.handleAudioTimeUpdate && $options.handleAudioTimeUpdate(...args)),
    onLoadedmetadata: _cache[10] || (_cache[10] = (...args) => _ctx.onLoadedmeta && _ctx.onLoadedmeta(...args))
  }, [_createElementVNode("source", {
    src: $data.audioPath,
    type: "audio/mpeg"
  }, null, 8, _hoisted_25)], 544)) : _createCommentVNode("", true), $data.listaudioPath ? (_openBlock(), _createElementBlock("audio", _hoisted_26, [_createElementVNode("source", {
    src: $data.listaudioPath,
    type: "audio/mpeg"
  }, null, 8, _hoisted_27)], 512)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("span", _hoisted_32, _toDisplayString(this.language ? 'recommend' : '推荐'), 1)]), _createElementVNode("div", {
    onClick: _cache[11] || (_cache[11] = (...args) => $options.replace && $options.replace(...args)),
    class: "replace"
  }, _toDisplayString(this.language ? 'change' : '换一换'), 1)]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.recommendList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-image swiper-slide",
      key: index,
      onClick: $event => $options.toDetail(item)
    }, [_createElementVNode("div", _hoisted_37, [_createElementVNode("img", {
      src: item.littleImage
    }, null, 8, _hoisted_38), _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.language ? item.en_explainObj : item.explainObj), 1)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", {
      class: "duration",
      innerHTML: item.intro
    }, null, 8, _hoisted_42), item.audioPath ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: _withModifiers($event => $options.listclickPlay(index, item), ["stop"]),
      class: "play"
    }, [_createElementVNode("i", {
      class: _normalizeClass($data.islistPlaying && $data.currentIndex === index ? 'icon-pause' : 'icon-video1')
    }, null, 2)], 8, _hoisted_43)) : _createCommentVNode("", true)]), $options.getAddress(item) ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_hoisted_45, _createElementVNode("span", _hoisted_46, _toDisplayString($options.getAddress(item)), 1)])) : _createCommentVNode("", true)])], 8, _hoisted_36);
  }), 128))])], 512)])])])]), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createBlock(_component_guideBottom, {
    key: 0
  })) : _createCommentVNode("", true)], 34);
}